/*
  PATISSLAND : Frais de preparation automatiques. v2 (code deplace du snippet
  snippets/frais-preparation.liquid vers ce fichier le 28/10/2026, logique inchangee).
  - Sous-total marchand (hors frais) < 15,00 EUR -> ajoute le produit frais (1 ex.)
  - >= 15,00 EUR ou panier vide                  -> retire le produit
  Reagit a 'patissland:cart:changed'. Ses ecritures passent par window.PL.cartCall
  -> non interceptees -> pas de boucle.
  Charge en defer : s'execute avant DOMContentLoaded, donc l'ecouteur ci-dessous
  est bien en place au chargement.
*/
(function(){
  var FEE_HANDLE = 'frais-de-preparation';
  var THRESHOLD_CENTS = 1500;

  // Repli minimal si la couche d'evenements n'est pas chargee.
  var PL = window.PL || {
    origFetch: (window.fetch ? window.fetch.bind(window) : null),
    cartCall: function(u,p){ return window.fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(p||{})}); }
  };

  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var feeVariantId = null;
  var syncQueued = false;
  var syncing = false;   // evite deux synchros simultanees
  var syncTimer = null;

  function getFeeVariantId(){
    if(feeVariantId) return Promise.resolve(feeVariantId);
    return PL.origFetch(rootUrl + 'products/' + FEE_HANDLE + '.js')
      .then(function(r){ if (!r.ok) throw new Error('Cart request failed'); return r.json(); })
      .then(function(p){
        feeVariantId = p.variants && p.variants[0] ? p.variants[0].id : null;
        return feeVariantId;
      })
      .catch(function(){ return null; });
  }

  function syncFee(){
    if(syncing){ syncQueued = true; return; }
    syncing = true;
    getFeeVariantId().then(function(vid){
      if(!vid){ finishSync(); return; }
      PL.origFetch(rootUrl + 'cart.js')
        .then(function(r){ if (!r.ok) throw new Error('Cart request failed'); return r.json(); })
        .then(function(cart){
          var feeLine = null, merchandiseTotal = 0;
          (cart.items || []).forEach(function(item){
            if(item.variant_id === vid){ feeLine = item; }
            else { merchandiseTotal += item.final_line_price; }
          });
          var needsFee = merchandiseTotal > 0 && merchandiseTotal < THRESHOLD_CENTS;
          var action = null;
          if(needsFee && !feeLine){
            action = PL.cartCall(rootUrl + 'cart/add.js', { items: [{ id: vid, quantity: 1 }] });
          } else if(needsFee && feeLine && feeLine.quantity !== 1){
            action = PL.cartCall(rootUrl + 'cart/change.js', { id: feeLine.key, quantity: 1 });
          } else if(!needsFee && feeLine){
            action = PL.cartCall(rootUrl + 'cart/change.js', { id: feeLine.key, quantity: 0 });
          }
          if(action){ action.then(function(response){ if (response.ok) refreshCartUI(); }).catch(function(){}).finally(finishSync); }
          else { finishSync(); }
        })
        .catch(finishSync);
    }).catch(finishSync);
  }

  function finishSync(){
    syncing = false;
    if(syncQueued){ syncQueued = false; scheduleSync(); }
  }

  function refreshCartUI(){
    // Impulse listens to cart:build on both cart forms; cart:refresh had no listener.
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('patissland:cart:synced'));
  }

  function scheduleSync(){
    if(syncing){ syncQueued = true; return; }
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFee, 600);
  }

  // 1) Le panier a change (action client) -> resynchro
  document.addEventListener('patissland:cart:changed', scheduleSync);
  // 2) Verrou au clic "Commander"
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]') : null;
    if(btn){ syncFee(); }
  }, true);
  // 3) Synchro au chargement (page panier + retours)
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', scheduleSync); }
  else { scheduleSync(); }
})();
